import styled from 'styled-components/macro';
import { h6 } from './typography';
import { colorPink } from './colors';
import { bodyFont} from './fonts';
import { ScrollBarStyles } from './scrollBar';

export const customModal = (style, isMobile = false) => ({
  modal: {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: '111111',
      direction: 'rtl',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    content: {
       width: isMobile ? '353px' : '642px',
      position: 'absolute',
      zIndex: '110',
      border: 'none',
      inset: 'unset',
    },
  },
});

export const customCoverModal = (style) => ({
  modal: {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: '111111',
      direction: 'rtl',
    },
    content: {
      width: '100vw',
      left: '0',
      position: 'fixed',
      zIndex: '90',
      height: '100vh',
      border: 'none',
    },
  },
});

export const Container = styled.div<{ alignItems?: string }>`
  position: relative;
  height: 100%;
  display: flex;
  ${ScrollBarStyles}
  flex-direction: column;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : '')};
`;

export const Title = styled.div<{ color?: string }>`
  margin-top: 6px;
  ${h6};
  color: ${({ color }) => (color ? color : colorPink)};
  margin-bottom: 1rem;
  font-family: ${bodyFont};
  text-align: center;

`;

export const Actions = styled.div<{isMobile?:boolean,justifyContent: string }>`
  font-family: ${bodyFont};
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent};
  width: 100%;
  padding: 0 60px;
  margin-top: 43px;
  align-items: center;
  flex: 1;
  flex-direction: ${({ isMobile }) => isMobile ? 'column' : 'row'};
  margin-bottom: ${({ isMobile }) => isMobile ? '35px' : '65px'};

`;

interface IProps {
  colorType?: string;
  isBold?: boolean;
  disabled?: boolean;
  outlined?: boolean;
  applyShadow?: boolean;
  fontSize?: number | string;
  type?: string;
  width?: number | string;
  height?: number | string;
  bottom?: number | string;
  padding?: string;
  isMargin?: string;
  borderProps?: string;
  textDecoration?: string;
  colorProps?: string;
  form?: string;
  isFontBold?: boolean;
  position?: string;
  lineHeight?: string;
  fontFamily?: string;
  cursor?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
}

export const Action = styled.button<IProps>`
background: ${(props) => props.colorType};
color: black;
min-width: 9rem;
border-radius: 0;
min-height: 54px;
text-decoration: ${({ textDecoration }) => textDecoration}
cursor: ${({ cursor }) => cursor};
font-size: ${({ fontSize }) => fontSize};
width: ${({ width }) => (width ? width : 'unset')}px;
position: ${({ position }) => position}
height: ${({ height }) => height};
bottom:  ${({ bottom }) => bottom};
padding: ${({ padding }) => padding};
margin-inline-end: ${(props) => props.isMargin};
border: ${(props) => props.borderProps};
color: ${(props) => props.colorProps};
text-align: center;
line-height: ${({ lineHeight }) => lineHeight};
font-weight: ${({ isFontBold }) => (isFontBold ? 'bold' : 'unset')};
`;
export const Logo = styled.div`
  margin: 2rem auto;
`;
